/**
 * Single source of truth for section → exam type, route, and labels.
 * Used by ExamSelectionPage and PreExamSetupPage to avoid duplicated conditionals.
 */

export type Section = 'Lezen' | 'Luisteren' | 'Schrijven' | 'Spreken' | 'KNM';

export const SECTIONS: Section[] = ['Lezen', 'Luisteren', 'Schrijven', 'Spreken', 'KNM'];

/** API exam type for GET /exams?type= */
export const SECTION_EXAM_TYPE: Record<Section, string> = {
  Lezen: 'reading',
  Luisteren: 'listening',
  Schrijven: 'writing',
  Spreken: 'speaking',
  KNM: 'knm',
};

/** Route path for the exam runner (with attemptId from startExam) */
export const SECTION_EXAM_PATH: Record<Section, string> = {
  Lezen: '/exam/reading',
  Luisteren: '/exam/listening',
  Schrijven: '/exam/writing',
  Spreken: '/exam/speaking',
  KNM: '/exam/knm',
};

/** Sections that call startExam(examId) and go to exam runner with attemptId */
export const SECTIONS_WITH_START_EXAM: Section[] = ['Lezen', 'Schrijven', 'Luisteren', 'Spreken', 'KNM'];

export function sectionUsesStartExam(section: Section): boolean {
  return SECTIONS_WITH_START_EXAM.includes(section);
}

export function getExamPath(section: Section): string {
  return SECTION_EXAM_PATH[section] ?? '/exam/reading';
}

export function getExamType(section: Section): string {
  return SECTION_EXAM_TYPE[section] ?? 'reading';
}
